// extracted by mini-css-extract-plugin
export var loanCardListContainer = "m_6";
export var loanContainer = "m_3";
export var loanTableContainer = "m_4";
export var newLoanOptionsContainer = "m_2";
export var titledListContainer = "m_5";